import React from "react";
import { Link } from "react-router-dom";
import { PiCaretRightThin } from "react-icons/pi";
import GlobalStyles from "../../global/GlobalStyles";

const Breadcrumbs = ({ items }) => {
  return (
    <div className={GlobalStyles.breadContainer}>
      {items.map((item, index) => (
        <React.Fragment key={index}>
          <Link to={item.path} className={GlobalStyles.breadLink}>
            {item.name}
          </Link>
          {index < items.length - 1 && (
            <PiCaretRightThin className={GlobalStyles.breadIcon} />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Breadcrumbs;
